import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';
import { useTicketInformation } from '@/hooks/useTicketInformation/useTicketInformation';
import { useTrackCheckoutButtonClick } from './useGoToCheckoutAction';

export const useLiveEventData = () => {
  const { id: eventId, startDate, isSeries, vertical, isOnline, hideStartDate, seriesId } = useBasicInfo();
  const [ticketInfo, loading] = useTicketInformation();
  const handleGetTicketsClick = useTrackCheckoutButtonClick({
    eventId,
    seriesId,
    hasEarlyBirdTickets: ticketInfo?.availability?.hasEarlyBirdTickets ?? null,
  });

  const hasError = !loading && !ticketInfo && !!startDate;

  return {
    eventId,
    startDate,
    isSeries,
    seriesId,
    isOnline,
    ticketInfo,
    vertical,
    hideStartDate,
    loading,
    hasError,
    handleGetTicketsClick,
  };
};
